var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86 86",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006DB3",
    d: "M43 0C19.26 0 0 19.26 0 43s19.26 43 43 43 43-19.26 43-43S66.74 0 43 0Zm-8.6 58.05v-30.1c0-1.19.96-2.15 2.15-2.15.47 0 .92.15 1.29.43l20.08 15.05c1.16.86 1.16 2.58 0 3.44L37.84 59.77c-.95.71-2.3.52-3.01-.43-.28-.37-.43-.82-.43-1.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFilled);
export default __webpack_public_path__ + "static/media/play_filled.a278d5270b585ba00753e570ce6dfdf0.svg";
export { ForwardRef as ReactComponent };